import React from "react";
import NewsletterThirtyTwo from "../component/NewsletterThirtyTwo";

function NewsletterThirtyTwoContainer() {
  return <NewsletterThirtyTwo />;
}

export default NewsletterThirtyTwoContainer;
